import { FiUser, FiLogOut, FiKey } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import './Topbar.css';
import { clearAuth, getAdmin } from '../../utils/auth';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';

export default function Topbar() {
  const navigate = useNavigate();
  const admin = getAdmin();
  const logoutHandler = async () => {
    await httpAction({ url: apis().authLogout, method: 'POST', silent: true });
    clearAuth();
    navigate('/admin/login');
  };
  return (
    <header className="atb">
      <div className="atb__left">{admin?.role?.replace('_', ' ') || 'Dashboard'}</div>
      <div className="atb__right">
        <button className="atb__logout" onClick={() => navigate('/admin/change-password')} title="Change password"><FiKey /></button>
        <div className="atb__user"><FiUser /> {admin?.name || 'Admin'}</div>
        <button className="atb__logout" onClick={logoutHandler} title="Logout"><FiLogOut /></button>
      </div>
    </header>
  );
}
